<template>
  <div id="app" class="unselectable">
    <div id="app-content" v-if="isAuthenticated">
      <header class="header">
        <ScrapeMenu @update="logoutEvent"></ScrapeMenu>
      </header>
      <main class="container-main">
        <div class="container-main--inner">
          <aside class="sidebar">
            <Filters
              :source-options="sourceOptions"
              :branche-options="brancheOptions"
              :target-word-options="targetWordOptions"
              :key="key"
              :currentPage="currentPage"
            ></Filters>
            <loader v-if="!this.isDoneLoading()" ref="Loader"></loader>
          </aside>
          <div class="content">
            <router-view></router-view>
          </div>
        </div>
      </main>
    </div>
    <div v-if="!isAuthenticated" class="login-page">
      <Login @update="loginEvent" class="login-holder"></Login>
    </div>
  </div>
</template>

<script>
import ScrapeMenu from "./components/ScrapeMenu.vue";
import Filters from "./components/Filters";
import { central_api_domain } from "./constants/endpoints";
import { b2b_portal_api_url } from "@/constants/endpoints";
import Loader from "./components/Loader";
import Login from "@/components/Login";

export default {
  name: "app",
  components: {
    ScrapeMenu,
    Filters,
    Loader,
    Login,
  },
  data() {
    return {
      currentPage: "",
      key: 1,
      brancheOptions: null,
      sourceOptions: null,
      targetWordOptions: null,
      pdfData: {
        companyId: "",
        company: {},
      },
      isAuthenticated: true,
      checkAuthenticationInterval: null,
      checkAuthenticationIntervalTime: 30000, //30 sec
    };
  },
  methods: {
    setCurrentPage(page) {
      this.currentPage = page;
    },
    getTargetWordFilterOptions() {
      fetch(central_api_domain + "targetwords")
        .then((res) => res.json())
        .then((result) => {
          let targetWords = [];
          result.forEach(function (word) {
            targetWords.push(word.value);
          });
          this.targetWordOptions = targetWords;
        });
    },
    getPlatformsOptions() {
      fetch(central_api_domain + "platforms")
        .then((res) => res.json())
        .then((result) => {
          let platforms = [];
          result.forEach(function (platform) {
            platforms.push(platform.platform);
          });
          this.sourceOptions = platforms;
        });
    },
    getBrancheOptions() {
      fetch(central_api_domain + "branches")
        .then((res) => res.json())
        .then((result) => {
          this.brancheOptions = result;
        });
    },
    setCompanyId(url) {
      this.pdfData.companyId = url;
    },
    setPdfCompany(company) {
      this.pdfData.company = company;
    },
    getPdfData() {
      return this.pdfData;
    },
    isDoneLoading() {
      return (
        this.brancheOptions != null &&
        this.sourceOptions != null &&
        this.targetWordOptions != null
      );
    },
    checkAuthentication() {
      let token = localStorage.getItem("token");
      if (token == null || token === "" || token === undefined) {
        this.isAuthenticated = false;
      } else {
        fetch(b2b_portal_api_url + "session/check", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.success === false) {
              this.isAuthenticated = false;
              this.logoutEvent();
            } else {
              if (
                this.brancheOptions === null ||
                this.sourceOptions === null ||
                this.targetWordOptions === null
              ) {
                this.preloadData();
              }
              if (this.checkAuthenticationInterval === null) {
                this.checkAuthenticationInterval = setInterval(() => {
                  this.checkAuthentication();
                }, this.checkAuthenticationIntervalTime);
              }
              this.isAuthenticated = true;
            }
          });
      }
    },
    preloadData() {
      this.getTargetWordFilterOptions();
      this.getPlatformsOptions();
      this.getBrancheOptions();
    },
    loginEvent() {
      this.isAuthenticated = true;
      this.$router.push("/companies/page/1");
      this.preloadData();
      this.$forceUpdate();
      this.checkAuthenticationInterval = setInterval(() => {
        this.checkAuthentication();
      }, this.checkAuthenticationIntervalTime);
    },
    logoutEvent() {
      clearInterval(this.checkAuthenticationInterval);
      localStorage.removeItem("token");
      localStorage.removeItem("userEmail");
      this.isAuthenticated = false;
      this.$forceUpdate();
    },
  },
  watch: {
    $route(to, from) {
      this.key = this.key + 1;
    },
  },
  created() {
    if (this.checkAuthenticationInterval == null) {
      let token = localStorage.getItem("token");
      if (token !== undefined && token !== null && token && token !== "") {
        this.checkAuthentication();
      } else {
        this.isAuthenticated = false;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.checkAuthenticationInterval);
  },
};
</script>

<style lang="scss"></style>
